import React from 'react';
import TitleHelmet from 'components/TitleHelmet';
import LabelQuiz from 'components/LabelQuiz';
import OtherCalcs from 'components/OtherCalcs'; // Corrected import path
// import 'css/quiz-page.css'; // We can create this if specific page styling is needed later

const quizQuestions = [
  {
    id: 1,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide 15 mg/mL
For subcutaneous injection only
Qty: 3mL       Rx#: 98765
Exp: 04/15/2025
Store refrigerated (2-8°C/36-46°F)
Different Pharmacy, LLC
789 Oak St, City, ST 12345
(555) 555-1234`,
    question: 'What is the concentration of tirzepatide in this vial?',
    options: ['5 mg/mL', '10 mg/mL', '15 mg/mL', '20 mg/mL'],
    correctAnswer: '15 mg/mL',
    explanation:
      'The concentration is clearly stated as 15 mg/mL on the label. This is the standard format showing concentration directly in mg/mL.',
  },
  {
    id: 2,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide 7.5mg/0.5mL
Total Volume: 3mL
For subcutaneous injection only
Rx#: 45678       Lot#: TZ0324A
Exp: 05/01/2025
Keep Refrigerated
Another Pharmacy Compounding
123 Pine Ave, City, ST 12345
(555) 555-9876`,
    question: 'If the vial shows 7.5mg/0.5mL, what is the actual concentration?',
    options: ['7.5 mg/mL', '15 mg/mL', '20 mg/mL', '25 mg/mL'],
    correctAnswer: '15 mg/mL',
    explanation:
      'Since 0.5mL is half a milliliter, and there are 7.5mg in that half mL, there must be twice as much (15mg) in a whole milliliter. So double 7.5mg to get the concentration of 15 mg/mL.',
  },
  {
    id: 3,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide/B12 12/0.5 mg/mL
Volume: 4mL       Rx#: 24680
Exp: 04/01/2025   Lot#: TZB0324C
Store in refrigerator
Discard after: 28 days from first use
Third Pharmacy Solutions
456 Maple St, City, ST 12345
(555) 555-4321`,
    question: 'In a vial containing Tirzepatide/B12 12/0.5 mg/mL, what is the tirzepatide concentration?',
    options: ['0.5 mg/mL', '12 mg/mL', '12.5 mg/mL', '15 mg/mL'],
    correctAnswer: '12 mg/mL',
    explanation:
      "When additives are present, look for the tirzepatide concentration only. Here it's 12 mg/mL, with B12 being an additional ingredient that is not relevant for dosing calculations.",
  },
  {
    id: 4,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide/Glycine cmpd. - 8.5MG - 5MG / ML
Volume: 3mL       Rx#: 34567
Exp: 05/15/2025   Lot#: TZG0324D
Store in refrigerator
Discard after: 28 days from first use
Valley Compounding Pharmacy
567 Pine St, City, ST 12345
(555) 555-8765`,
    question: 'In this vial where dashes separate the components, what is the tirzepatide concentration?',
    options: ['5 mg/mL', '8.5 mg/mL', '13.5 mg/mL', '15 mg/mL'],
    correctAnswer: '8.5 mg/mL',
    explanation:
      'When components are separated by dashes, the concentrations still match the order of ingredients. Since tirzepatide is first, use the first number: 8.5 mg/mL.',
  },
  {
    id: 5,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide-B12 Compound 10mg-500mcg/mL
Total Volume: 2.5mL
Rx#: 89012       Lot#: TZB0324E
Exp: 04/30/2025
Keep Refrigerated
Summit Pharmacy Solutions
890 Oak Ave, City, ST 12345
(555) 555-2345`,
    question: 'What is the tirzepatide concentration in this vial that uses mcg for the additive?',
    options: ['500 mcg/mL', '10 mg/mL', '10.5 mg/mL', '15 mg/mL'],
    correctAnswer: '10 mg/mL',
    explanation:
      "Don\'t be confused by the different units (mg vs mcg) - just focus on the tirzepatide amount. Since tirzepatide is listed first, use the first number: 10 mg/mL.",
  },
  {
    id: 6,
    labelText: `COMPOUNDED MEDICATION
Tirzepatide 5mg/0.5mL
Total Volume: 4mL
For subcutaneous injection only
Rx#: 78901       Lot#: TZ0324F
Exp: 05/30/2025
Keep Refrigerated
Precision Compounding
234 Maple Ave, City, ST 12345
(555) 555-6789`,
    question: 'What is the concentration when the label shows 5mg/0.5mL?',
    options: ['5 mg/mL', '10 mg/mL', '15 mg/mL', '20 mg/mL'],
    correctAnswer: '10 mg/mL',
    explanation:
      'The label shows 5mg in 0.5mL (half a milliliter). To find the concentration per whole milliliter, double the first number: 5mg × 2 = 10 mg/mL. Remember, when you see an amount per 0.5mL, double it to get the concentration per mL.',
  },
];

const QuizConcentrationLabel: React.FC = () => {
  return (
    <div className="page-container quiz-concentration-label-page">
      {' '}
      {/* Added a general class for page styling */}
      <TitleHelmet title="Concentration Label Quiz | Fat Scientist" />
      <section className="content-section">
        {' '}
        {/* Using existing class for consistent content width */}
        <h2>Test Your Label Reading Skills</h2>
        <p>
          Practice identifying the medication concentration from various example labels. This will help you accurately
          use the dosage calculators.
        </p>
        <LabelQuiz questions={quizQuestions} />
      </section>
      <section className="content-section other-calculators-section">
        <OtherCalcs />
      </section>
      {/* Basic styling for the page, can be moved to a CSS file if it grows */}
      <style>{`
        .quiz-concentration-label-page {
          padding: 2rem 0;
        }
        .content-section {
          max-width: 800px; /* Consistent with FindingConcentration page */
          margin: 0 auto 2rem auto; /* Centering and adding bottom margin */
          padding: 0 1rem;
        }
        .other-calculators-section {
          margin-top: 3rem; /* Add some space above other calculators */
        }
      `}</style>
    </div>
  );
};

export default QuizConcentrationLabel;
